import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-center font-weight-black text-red" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black" }, "Laborátório: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black" }, "Registro MS: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black" }, "Tarja: ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black text-primary" }, "Tipo Produto: ", -1)
const _hoisted_6 = { class: "font-weight-regular" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black" }, "Categoria: ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black" }, "Unidade: ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black text-primary" }, "Hospitalar: ", -1)
const _hoisted_10 = { class: "font-weight-regular" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black" }, "NCM: ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black text-primary" }, "CEST: ", -1)
const _hoisted_13 = { class: "font-weight-regular" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black text-primary" }, "Classe Terapêutica: ", -1)
const _hoisted_15 = { class: "font-weight-regular" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("thead", { class: "font-weight-black text-white" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "Código Barras"),
    /*#__PURE__*/_createElementVNode("td", null, "Data")
  ])
], -1)
const _hoisted_17 = { hidden: "" }
const _hoisted_18 = { class: "ml-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", { class: "font-weight-black text-white" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "Principio ativo"),
    /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "DCB")
  ])
], -1)
const _hoisted_20 = { hidden: "" }
const _hoisted_21 = { class: "ml-3" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", { class: "font-weight-black bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "12%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 0% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "12%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 12% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "12%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 17% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "12%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 18% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "12%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 19% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "12%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 19,5% "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      width: "12%",
      class: "text-center text-white font-weight-bold"
    }, " ICMS 20% ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-red text-white font-weight-medium" }, " Custo "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " Venda "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-red font-weight-medium" }, " Custo "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " Venda "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-red font-weight-medium" }, " Custo "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " Venda "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-red font-weight-medium" }, " Custo "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " Venda "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-red font-weight-medium" }, " Custo "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " Venda "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-red font-weight-medium" }, " Custo "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " Venda "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-red font-weight-medium" }, " Custo "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-white font-weight-medium" }, " Venda ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      dense: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", {
              class: _normalizeClass(["text-center font-weight-black", _ctx.medicamento.dataInativo != null ? 'bg-red' : 'bg-primary'])
            }, _toDisplayString(_ctx.medicamento.nomeProd) + " - " + _toDisplayString(_ctx.medicamento.nomeApre), 3)
          ]),
          _: 1
        }),
        (_ctx.medicamento.dataInativo != null)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "12",
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_1, " Medicamento foi descontinuado em " + _toDisplayString(_ctx.convertToDate(_ctx.medicamento.dataInativo)), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      dense: true,
      class: "text-primary ml-3 mr-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "ml-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_2,
              _createElementVNode("span", null, _toDisplayString(_ctx.medicamento.laboratorio ? _ctx.medicamento.laboratorio.nome : ''), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          sm: "12",
          xs: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_3,
              _createElementVNode("span", null, _toDisplayString(_ctx.medicamento.registro), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          sm: "12",
          xs: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_4,
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.corTarja)
              }, _toDisplayString(_ctx.tarjaToText(_ctx.medicamento.tarja)), 3)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          sm: "12",
          xs: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.medicamento.tipoProduto), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          sm: "12",
          xs: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_ctx.medicamento.categ), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          sm: "12",
          xs: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_8,
              _createElementVNode("span", null, _toDisplayString(_ctx.medicamento.unidade), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          sm: "12",
          xs: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.medicamento.hospitalar), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          md: "6",
          sm: "12",
          xs: "12"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_11,
              _createElementVNode("span", null, _toDisplayString(_ctx.medicamento.ncm), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          md: "6",
          sm: "12",
          xs: "12"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.medicamento.cest), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          md: "12",
          xs: "12"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.medicamento.classe_ter), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      dense: true,
      class: "text-white"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          md: "6",
          sm: "12",
          xs: "12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, {
              height: "100px",
              density: "compact"
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicamento.codigosDeBarras, (key, value, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: value }, [
                    _createElementVNode("td", _hoisted_17, _toDisplayString(index), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(value), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(key), 1)
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          md: "6",
          sm: "12",
          xs: "12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, {
              height: "100px",
              density: "compact"
            }, {
              default: _withCtx(() => [
                _hoisted_19,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicamento.principios, (key, value, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: value }, [
                    _createElementVNode("td", _hoisted_20, _toDisplayString(index), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(key.nome), 1)
                    ]),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(key.dcb), 1)
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs, {
          modelValue: _ctx.precoSelecionado,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.precoSelecionado) = $event)),
          "align-tabs": "title",
          "fixed-tabs": ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicamento.precos, (n, value, index) => {
              return (_openBlock(), _createBlock(_component_v_tab, {
                key: index,
                value: index,
                onClick: ($event: any) => (_ctx.preco(n.precos))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.preparaTexto(value)), 1)
                ]),
                _: 2
              }, 1032, ["value", "onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      dense: true,
      class: "text-primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { md: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, {
              height: "120px",
              density: "compact"
            }, {
              default: _withCtx(() => [
                _hoisted_23,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(_ctx.precoVigente[0].custo || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(_ctx.precoVigente[0].venda || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(_ctx.precoVigente[1].custo || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(_ctx.precoVigente[1].venda || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(_ctx.precoVigente[2].custo || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(_ctx.precoVigente[2].venda || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(_ctx.precoVigente[3].custo || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(_ctx.precoVigente[3].venda || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(_ctx.precoVigente[4].custo || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(_ctx.precoVigente[4].venda || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(
                                _ctx.precoVigente[5].icms === '19,5' ?
                                    _ctx.precoVigente[5].custo || '-'
                                    : '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(
                                _ctx.precoVigente[5].icms === '19,5' ?
                                    _ctx.precoVigente[5].venda || '-'
                                    : '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(
                                _ctx.precoVigente[5].icms === '19,5' ?
                                    _ctx.precoVigente[6].custo || '-'
                                    : _ctx.precoVigente[5].custo || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascaraMoney(
                                _ctx.precoVigente[5].icms === '19,5' ?
                                    _ctx.precoVigente[6].venda || '-'
                                    : _ctx.precoVigente[5].venda || '-')), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}